import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './PhoneScreen.css';
import Logo from '../components/Logo';

function PhoneScreen({ setIsAuthenticated }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      setError('Please enter a phone number');
      return;
    }

    setIsLoading(true);
    setError('');

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      user_type: 'vehicle_owner',
      phone_number: phoneNumber
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        'https://api.rtoxpert.com/api/users/select-type',
        requestOptions
      );
      const result = await response.json();

      if (response.ok) {
        localStorage.setItem('phoneNumber', phoneNumber);
        navigate('/otp');
      } else {
        setError(result.message || 'Failed to send OTP. Please try again.');
      }
    } catch (error) {
      setError('Something went wrong. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="phone-screen">
      <Helmet>
        <title>Login with Phone | VAAHANBUDDY - Vehicle Services in India</title>
        <meta name="description" content="Start your VAAHANBUDDY journey by verifying your phone number with OTP. Access hassle-free RTO services, vehicle insurance, and buy-sell solutions." />
      </Helmet>
      <div className="phone-left">
        <div className="phone-logo"><Logo /></div>
        <div className="phone-text">
          <h1>Simplify Your RTO Tasks with VAAHANBUDDY</h1>
          <p>Get all your RTO-related services delivered right to your doorstep. From vehicle registration to license renewals, VAAHANBUDDY makes the process hassle-free, saving you time and effort.</p>
        </div>
        <form onSubmit={handleSubmit} className="phone-form">
          <div className="input-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              id="phone"
              type="tel"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              placeholder="Enter phone number"
              disabled={isLoading}
            />
            {error && <p className="error-message">{error}</p>}
          </div>
          <button type="submit" className="verify-btn" disabled={isLoading}>
            {isLoading ? 'Sending OTP...' : 'Verify with OTP'}
          </button>
        </form>
        <p className="terms-text">
          By logging in, you agree to our Privacy Policy and Terms & Conditions
        </p>
      </div>
      <div className="phone-right">
        <div
          className="illustration"
          role="img"
          aria-label="Car Service Illustration"
        />
      </div>
    </div>
  );
}

export default PhoneScreen;
